import React from 'react'

const Success = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g transform="translate(.077 .077)">
        <g>
          <path
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M3.719 7.884L6.235 10.4l3.032-3.032 2.774-2.774"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default React.memo(Success)
